/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Faq_Q7_QuestionInputs */

const en_home_faq_q7_question = /** @type {(inputs: Home_Faq_Q7_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why should I activate my portal access?`)
};

const fr_home_faq_q7_question = /** @type {(inputs: Home_Faq_Q7_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi devrais-je activer mon accès au portail ?`)
};

/**
* | output |
* | --- |
* | "Why should I activate my portal access?" |
*
* @param {Home_Faq_Q7_QuestionInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_faq_q7_question = /** @type {((inputs?: Home_Faq_Q7_QuestionInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Faq_Q7_QuestionInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_faq_q7_question(inputs)
	return fr_home_faq_q7_question(inputs)
});